// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #000000;
}

.padding {
  padding: 7rem !important;
}

@media (max-width: 767.98px) {
  .padding {
    padding: 0px !important;
  }
}
.intro .buttons a.btn {
  margin: 10px;
  padding: 10px 30px;
}

.btn {
  position: relative;
  display: inline-block;
  outline: none;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 400;
  text-shadow: 0 0 1px rgba(255, 255, 255, 0.3);
  font-size: 14px;
  font-weight: 700;
  width: 250px;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
}

.animated h2 {
  text-align: center;
  color: black;
}

.animated p {
  text-align: center;
  color: black;
}

.buttons {
  text-align: center;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
